import {InjectionToken} from '@angular/core'
import {IEnvironment} from './data-types'

/**
 * Defines and exports an injection token that replaces the browser
 * window object.
 */
export const WINDOW = new InjectionToken<Window>('window')
export const LOCAL_STORAGE = new InjectionToken<Storage>('localStorage')
export const ENVIRONMENT = new InjectionToken<IEnvironment>('environment')